import React from 'react';
import ReactDOM from 'react-dom/client';
import { store } from './store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import './i18n';

import App from './App';
import 'mapbox-gl/dist/mapbox-gl.css';
import './index.scss';

import { registerSW } from 'virtual:pwa-register';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
);

// Register the service worker
if ('serviceWorker' in navigator) {
  registerSW({
    onNeedRefresh() {// handle a new service worker update
    },
    onOfflineReady() {// handle when the app is ready to work offline
    },
  });

  // window.addEventListener('load', () => {
  //   navigator.serviceWorker.register('/sw.js').then((registration) => {
  //     console.log('Service Worker registered with scope: ', registration.scope);
  //   }).catch((registrationError) => {
  //     console.log('Service Worker registration failed: ', registrationError);
  //   });
  // });
}
